var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"rk-btn",class:{size: _vm.size, 'ghost': _vm.ghost},on:{"click":function($event){return _vm.$emit('click')}}},[_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":"#chevron-left"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }